import $ from 'jquery';
import { sliderSetting } from '@/shared/calendar';

$(() => {
    // カレンダーのカルーセル設定
    sliderSetting(false, false);

    // 日付選択にフォーカスした
    let $dateTarget = null; // 選択中の input
    $('.form-date__input').on('focus', e => {
        $dateTarget = $(e.currentTarget);
        $('.calendar, .calendar__bg').show();
        $('.js-slick__list.slick-initialized').slick('setPosition'); // 非表示要素にslick再適応
    });

    // 希望日を選択した
    $('.calendar').on('click', ".calendar__day-item:not('.is-disabled')", e => {
        let date = $(e.currentTarget)
            .find('input')
            .val();
        if (date && date.length) {
            // フォームに日付の入力
            $dateTarget.val(date);
            $(".calendar__day-item input[type='checkbox']").prop('checked', false); // 日付のチェック解除
            $('.calendar, .calendar__bg').hide(); // カレンダー閉じる
        }
    });

    // 第一希望日のバツボタンをクリックした際、第一希望日の日付と時刻をリセット
    $('.js-date_cancel1').on('click', e => {
        document.getElementById('preferred_date1').value = "";
        if (document.getElementById('reserve_time1')){
            document.getElementById('reserve_time1').value = "";
        }else if (document.getElementById('reserve_hour1') && document.getElementById('reserve_minute1')){
            document.getElementById('reserve_hour1').value = "";
            document.getElementById('reserve_minute1').value = "";
        }
    });

    // 時刻（時）を変更したとき 00分にセット[通常予約・資料請求のみ]
    $("[id^='reserve_hour']").on('change', e => {
        const $target = $(e.currentTarget);
        const timeTarget = $target
            .prop('id')
            .replace('reserve_hour', '#reserve_minute'); // 対応する[分]
        $(timeTarget).val('00');
    });

    // カレンダーモーダル背景押下でカレンダー閉じる
    $('.calendar__bg, .calendar__close').on('click', () => {
        $('.calendar, .calendar__bg').hide();
        return false;
    });

    // EnterでSubmitされるのを防ぐ
    $('form:not([data-enableSubmit])').on('keydown.disableSubmit', e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            return false;
        }
    });
});
